/**
 * Update total wishlist compare
 */

function countCompare (){
  const listItem = localStorage.getItem('compareItems').split(',');
  const listItemNew = listItem.filter(element => element !== '');

  document.querySelectorAll('[data-type-count="compare"]').forEach((item)=>{
    item.innerHTML = listItemNew.length;
  });
}

function countWishlist (){
  const listItem = localStorage.getItem('wishlistItems').split(',');
  const listItemNew = listItem.filter(element => element !== '');

  document.querySelectorAll('[data-type-count="wishlist"]').forEach((item)=>{
    item.innerHTML = listItemNew.length;
  });
}

function countCompareWishlist (type){
  if(type == 'compare'){
    countCompare();
  } else if (type == 'wishlist'){
    countWishlist();
  }
}

window.addEventListener('DOMContentLoaded', () => {
  if(localStorage.getItem('compareItems') !== null){
    countCompare();
  }

  if(localStorage.getItem('wishlistItems') !== null){
    countWishlist();
  }
});

/**
 * Compare, Wishlist
 */
function wishlistCompareAdded(element){
  const buttonType = element.getAttribute('data-type');
  const productHandle = element.getAttribute('data-product-handle');
  var listItems = '';
  var listItemsArray = [];
  
  if(buttonType == 'wishlist'){
    listItems = localStorage.getItem('wishlistItems');
  } else {
    listItems = localStorage.getItem('compareItems');
  }

  if(listItems){
    listItemsArray = listItems.split(",");

    if(listItemsArray.includes(productHandle)){
      element.classList.add('added');
    }
  }
}

class CompareWishlist extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', this.addCompareWishlist);
    wishlistCompareAdded(this)
  }

  addCompareWishlist(){
    const buttonType = this.getAttribute('data-type');
    const productHandle = this.getAttribute('data-product-handle');

    this.classList.add('loading');

    var dataString = ''

    if(buttonType == 'wishlist'){
      dataString = localStorage.getItem('wishlistItems')
    } else{
      dataString = localStorage.getItem('compareItems')
    }

    if(dataString){
      var listItems = '';

      if(buttonType == 'wishlist'){
        listItems = localStorage.getItem('wishlistItems');
      } else {
        listItems = localStorage.getItem('compareItems');
      }

      var listItemsArray = listItems.split(",");
      
      if(!listItemsArray.includes(productHandle)){
        listItems = listItems + ',' + productHandle;
      }

      if(buttonType == 'wishlist'){
        localStorage.setItem('wishlistItems', listItems);
        countWishlist();
      } else {
        localStorage.setItem('compareItems', listItems);
        countCompare();
      }
    } else {
      if(buttonType == 'wishlist'){
        localStorage.setItem('wishlistItems', productHandle);
        countWishlist();
      } else {
        localStorage.setItem('compareItems', productHandle);
        countCompare();
      }
    }

    setTimeout(() => {
      this.classList.remove('loading');
      this.classList.add('added');
    }, 400);
  }
}

customElements.define('tapita-wishlist-compare', CompareWishlist);

/**
 * Remove item wishlist compare
 */
class RemoveWishlistCompare extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', this.removeWishlistCompareItem);
  }

  removeWishlistCompareItem(){
    const productHandleItem = this.getAttribute('data-remove-item');
    const removeType = this.getAttribute('data-type');
    var listItem  = [];
    var newListItemArray = [];
    
    if(removeType == 'compare'){
      listItem = localStorage.getItem('compareItems').split(',');
    } else {
      listItem = localStorage.getItem('wishlistItems').split(',');
    }

    newListItemArray = listItem.filter(item => item !== productHandleItem)

    if(removeType == 'compare'){
      localStorage.setItem('compareItems', newListItemArray.toString());
      this.closest('.scroll-item').remove();
      countCompare();
    } else {
      localStorage.setItem('wishlistItems', newListItemArray.toString());
      this.closest('.item-wishlist').remove();
      countWishlist();
    }
  }
}

customElements.define('tapita-remove-wishlist-compare', RemoveWishlistCompare);